import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { AU_ROOT_DOMAIN, getRegion, getRootDomain, GLOBAL_ROOT_DOMAIN, insertSubdomain } from "@util/domain";
import { openConsentSettings } from "@util/ga";
import styles from "./Footer.module.css";

interface FooterProps {
    isLoggedIn?: boolean;
}

const Footer: React.FC<FooterProps> = ({ isLoggedIn = false }) => {
    return (
        <footer className={styles.footer}>
            <div className={styles.navLinksContainer}>
                {!isLoggedIn && (
                    <>
                        <a href={insertSubdomain(getRootDomain(), "notices")} className={styles.navLink} target="_blank" rel="noopener noreferrer">Death & Funeral Notices</a>
                        <a href={insertSubdomain(getRootDomain(), "memorials")} className={styles.navLink} rel="noopener noreferrer">View Online Memorials</a>
                        <a href={`${getRootDomain()}/pet-memorials`} className={styles.navLink} rel="noopener noreferrer">Pet Memorials</a>
                        <a href="/" className={styles.navLink} rel="noopener noreferrer">Memorial Hub</a>
                        <a href="https://apps.apple.com/au/app/forever-in-our-hearts/id6744423086" className={styles.navLink} target="_blank" rel="noopener noreferrer">App</a>
                        <a href={`${getRootDomain()}/blog`} className={styles.navLink} rel="noopener noreferrer">Blog</a>
                        <a href="https://funeralquestions.net" className={styles.navLink} target="_blank" rel="noopener noreferrer">Funeral Questions</a>
                        <a href={`${getRootDomain()}/funeral-director-network`} className={styles.navLink} rel="noopener noreferrer">Funeral Director Network</a>
                    </>
                )}
                <a href={`${getRootDomain()}/terms-and-conditions`} className={styles.navLink} rel="noopener noreferrer">Terms of Use</a>
                <a href={`${getRootDomain()}/privacy-policy`} className={styles.navLink} rel="noopener noreferrer">Privacy Policy</a>
                {getRegion() === "global" && (
                    <button
                        type="button"
                        className={`${styles.navLink} ${styles.linkButton}`}
                        onClick={openConsentSettings}
                    >
                        Cookie Settings
                    </button>
                )}
                {isLoggedIn && (
                    <>
                        <NavLink to="/support" className={styles.navLink}>Support</NavLink>
                    </>
                )}
            </div>
            <div className={styles.footerTextContainer}>
                <span className={styles.footerText}>
                    &copy; 2024-{new Date().getFullYear()}
                    &nbsp;
                    <a href={getRootDomain()} className={styles.noUnderline} target="_blank" rel="noopener noreferrer">
                        Forever In Our Hearts
                    </a>
                    {" Pty Ltd"}
                    {" | "}
                    {getRegion() === "au" ? (
                        <a href={`https://${GLOBAL_ROOT_DOMAIN}`} className={styles.noUnderline} target="_blank" rel="noopener noreferrer">
                            International
                        </a>
                    ) : (
                        <a href={`https://${AU_ROOT_DOMAIN}`} className={styles.noUnderline} target="_blank" rel="noopener noreferrer">
                            Australia
                        </a>
                    )}
                </span>
            </div>
        </footer>
    );
};

export default Footer;